import '../style/cardStyle.css';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import RepeatNumberOverlay from './RepeatNum';
import { useLocation } from 'react-router-dom';
import { numDecreaseM, prograssNumM, showInfoM } from '../store/reducers/athkarElmasaaSlice';
import { numDecreaseS, prograssNumS, showInfoS } from '../store/reducers/athkarEsabahSlice';
import { numDecreaseN, prograssNumN, showInfoN } from '../store/reducers/athkarAlnomSlice';
import { numDecreaseSL, prograssNumSL, showInfoSL } from '../store/reducers/athkarEsalahSlice';
import { numDecreaseW, prograssNumW, showInfoW } from '../store/reducers/werdAlthekrSlice';
import { numDecreaseMD, prograssNumMD, showInfoMD } from '../store/reducers/athkarMudafaSlice';

const renderContentWithNewlines = (text) => {
  return text.split('break').map((line) => (
    <>
      {line}
      <br />
    </>
  ));
};
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <InfoIcon {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(360deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const arabicMap = [
  "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"
];

function replaceDigitsWithArabic(text) {
  return text.replace(/\d/g, (digit) => arabicMap[digit - 1]);

}

export default function CardCom({ card }) {
  const dispatch = useDispatch();
  const [showRepeatOverlay, setShowRepeatOverlay] = useState(false);
  const [repeatClicked, setRepeatClicked] = useState(null);
  const location = useLocation();
  const contentRef = useRef(null);
  const cardItemLengthPer = 100 / card.length
  const handleExpandClick = useCallback((id) => {
    if (location.pathname === "/athkarElmasaa") {
      dispatch(showInfoM(id));
    } else if (location.pathname === "/athkarEsabah") {
      dispatch(showInfoS(id));
    } else if (location.pathname === "/athkarElnom") {
      dispatch(showInfoN(id));
    } else if (location.pathname === "/athkarEsalah") {
      dispatch(showInfoSL(id));
    } else if (location.pathname === "/werdAlthekr") {
      dispatch(showInfoW(id));
    } else if (location.pathname === "/AlathkarAlmudafa") {
      dispatch(showInfoMD(id));
    }
  }, [dispatch, location.pathname]);

  const handleRepeatClick = useCallback((id) => {

    const clickedCard = card.find(item => item.id === id);
    if (!clickedCard) return;

    if (clickedCard.repeat > 0) {


      if (location.pathname === "/athkarElmasaa") {
        dispatch(numDecreaseM(id));
      } else if (location.pathname === "/athkarEsabah") {
        dispatch(numDecreaseS(id));
      } else if (location.pathname === "/athkarElnom") {
        dispatch(numDecreaseN(id));
      } else if (location.pathname === "/athkarEsalah") {
        dispatch(numDecreaseSL(id));
      } else if (location.pathname === "/werdAlthekr") {
        dispatch(numDecreaseW(id));
      } else if (location.pathname === "/AlathkarAlmudafa") {
        dispatch(numDecreaseMD(id));
      }

      setRepeatClicked(id);
      setShowRepeatOverlay(true);
    }

    if (clickedCard.repeat === 1) {
      if (location.pathname === "/athkarElmasaa") {
        dispatch(prograssNumM(cardItemLengthPer));

      } else if (location.pathname === "/athkarEsabah") {
        dispatch(prograssNumS(cardItemLengthPer));
      } else if (location.pathname === "/athkarElnom") {
        dispatch(prograssNumN(cardItemLengthPer));
      } else if (location.pathname === "/athkarEsalah") {
        dispatch(prograssNumSL(cardItemLengthPer));
      } else if (location.pathname === "/werdAlthekr") {
        dispatch(prograssNumW(cardItemLengthPer));
      } else if (location.pathname === "/AlathkarAlmudafa") {
        dispatch(prograssNumMD(cardItemLengthPer));
      }
    }
  }, [cardItemLengthPer, dispatch, card, location.pathname]);

  const handleCloseRepeatOverlay = () => {
    setShowRepeatOverlay(false);
    setRepeatClicked(null);
  };

  useEffect(() => {
    if (contentRef.current) {
      const elements = contentRef.current.querySelectorAll('.ArabicNumber');
      elements.forEach(element => {
        element.innerHTML = replaceDigitsWithArabic(element.innerHTML);
      });
    }


  }, [card]);




  return (
    <div id='Arabic'>
      <div className="ag-format-container " ref={contentRef}>
        <div className="ag-courses_box " >
          {card.map((cardItem) => (

            <div className="ag-courses_item" key={cardItem.id}>
              <div className={`ag-courses-item_link ${cardItem.repeat !== 0 ? 'pointer' : ''}`}>
                {cardItem.repeat !== 0 && <div className="ag-courses-item_bg"
                  disabled={cardItem.repeat === 0}
                  style={{ pointerEvents: 'none' }}
                ></div>}
                <Card
                  onClick={() => handleRepeatClick(cardItem.id)}
                  sx={{
                    bgcolor: cardItem.repeat === 0 ? '#a5cfdd25' : 'background.paper',
                  }}>
                  <CardContent
                    className={`cardContent ArabicNumber ${cardItem.repeat !== 0 ? 'pointer' : ''}`}
                    disabled={cardItem.repeat === 0}
                  >
                    <Typography

                      variant="body2"
                      className={cardItem.quran === true ? "quran-text" : "normal-text"}

                    >
                      {renderContentWithNewlines(cardItem.content)}
                    </Typography>
                  </CardContent>
                  <CardActions disableSpacing className='cardAction'>
                    <IconButton
                      sx={{ color: "text.primary" }}
                      disabled={cardItem.repeat === 0}
                      aria-label="repeat"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRepeatClick(cardItem.id);
                      }}
                    >
                      <RepeatOutlinedIcon />
                    </IconButton>
                    <Typography className='' sx={{ color: "text.primary" }}>{cardItem.repeat}</Typography>
                    {cardItem.info && (
                      <ExpandMore
                        className='card pointer '
                        sx={{ color: "text.primary" }}
                        expand={cardItem.showInfo}
                        onClick={() => handleExpandClick(cardItem.id)}
                        aria-expanded={cardItem.showInfo}
                        aria-label="show more"
                      >
                        <ExpandMoreIcon />
                      </ExpandMore>
                    )}
                  </CardActions>
                  <Collapse in={cardItem.showInfo} timeout="auto" unmountOnExit>
                    <CardContent>
                      <Typography
                        className='info'
                        sx={{ color: "text.primary", fontSize: "1.3rem", borderTop: "1px solid #fff", paddingTop: "1rem" }}
                      >
                        {cardItem.info}
                      </Typography>
                    </CardContent>
                  </Collapse>
                </Card>
              </div>
            </div>
          ))}
          {showRepeatOverlay && repeatClicked !== null && (
            <RepeatNumberOverlay
              repeat={card.find(item => item.id === repeatClicked)?.repeat}
              onClose={handleCloseRepeatOverlay}
            />
          )}
        </div>
      </div>
    </div >
  );
}
